import { filterConstants } from "../constants";
import { useQueryString } from "./useQueryString";

interface IPageQueryPrefixParams {
  queryStringPrefix: string;
}

export function useGetPageQueryParams(
  prefixParams: IPageQueryPrefixParams = {
    queryStringPrefix: "",
  }
) {
  const { queryStringPrefix } = prefixParams;
  const queryStringPrefixWithDot = !!queryStringPrefix
    ? `${queryStringPrefix}.`
    : queryStringPrefix;

  const query = useQueryString();

  const page = query.get(
    `${queryStringPrefixWithDot}${filterConstants.currentPageKey}`
  ); // currentPageKey
  const page_size = query.get(
    `${queryStringPrefixWithDot}${filterConstants.pageSizeKey}`
  ); // pageSizeKey
  const search = query.get(
    `${queryStringPrefixWithDot}${filterConstants.searchKey}`
  ); // searchKey

  return {
    page,
    page_size,
    search,
  };
}
